// extracted by mini-css-extract-plugin
module.exports = {"tool":"ConclusionGenerator_tool__D9C3f"};